import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import BaseTableCell from 'components/molecules/TableCells/BaseTableCell/BaseTableCell';

const StyledButtonTableCell = styled(BaseTableCell)`
  ${ComponentStyles}
`;

StyledButtonTableCell.propTypes = {
  theme: PropTypes.object
};

export default StyledButtonTableCell;
